// extracted by mini-css-extract-plugin
module.exports = {"root":"UserProfileLink_root__2cr7G px-2 py-6","name":"UserProfileLink_name__39qwW","logout":"UserProfileLink_logout__1HNhL"};